import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";

import http from "../../../services/httpServices";

import Container from "../../../components/ui/Container";
import LoadingIcon from "../../../components/ui/LoadingIcon";
import SideTitle from "../../../components/ui/SideTitle";
import CourseCard from "../../../components/ui/CourseCard";
import auth from "../../../services/authServices";
import Button from "../../../components/ui/Button";
import CenterIcon from "../../../components/ui/CenterIcon";
import { motion, AnimatePresence } from "framer-motion";
import CourseCarousel from "../../../components/ui/CourseCarousel";
import { useLanguage } from "../../../context/LanguageContext";

const CoursesWithCategories = ({
    titleFirst = false,
    titleLast,
    isSubCategorie = false,
    id = 1,
    count = "",
    api = `/api/categories/${id}/sellables`,
    className = "",
    grid = "normal",
    noCoursesPlaceholder = ` سيتم أضافه محتوي ${titleFirst} ${titleLast} قريبا`,
    coursesList = false,
    isPrepaid = false,
    onPrepaidClick = null,
    initialShowingCourses = true,
}) => {
    const [courses, setCourses] = useState([]);
    const [categories, setCategories] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [showCourses, setShowCourses] = useState(initialShowingCourses);
    const { language } = useLanguage();
    const placeholders = {
        en: `New ${titleFirst} ${titleLast} content will be added soon.`,
        ar: `سيتم أضافه محتوي ${titleFirst} ${titleLast} قريبًا`,
        de: `Neue ${titleFirst} ${titleLast} werden bald hinzugefügt.`,
    };

    if (!className.includes("space-x")) {
        if (grid === "normal") {
            className += ` grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-10`;
        } else {
            className += ` grid-cols-1 lg:grid-cols-2 gap-5`;
        }
    }

    const [placeholder, setPlaceholder] = useState(
        <div className="font-h2 col-span-1 md:col-span-2 lg:col-span-3 py-20">
            <span className="flex-center-both space-x-3 space-x-reverse">
                <LoadingIcon className={"font-h1 text-teal-600 dark:text-teal-400"} />
                <span>{placeholders[language]}</span>
            </span>
        </div>
    );
    const getCourses = async (getAll = false) => {
        try {
            setIsLoading(true);
            if (!showAll) {
                const token = auth.getToken();
                const config = auth.getAuthConfig(token);
                count = getAll ? "all" : count;
                const link = count ? `${api}/${count}` : api;
                const { data } = await http.get(link, config);

                setCourses([]);
                setCourses(data);

                let categoryFees = {}; // Store total fees per category
                let courseCategories = data.map((course) => course.category);
                let uniqueCategories = [];
                let isNoCategory = false;

                data.forEach((course) => {
                    if (!course.category || !course.category.id) {
                        isNoCategory = true;
                        return;
                    }
                    const categoryId = course.category.id;
                    if (!categoryFees[categoryId]) {
                        categoryFees[categoryId] = 0;
                    }

                    const coursePrice = Number(course.price) || 0;

                    categoryFees[categoryId] += coursePrice;

                    console.log(`Category ${categoryId} Total Fees:`, categoryFees[categoryId]);

                    let existingCategory = uniqueCategories.find((c) => c.id === categoryId);

                    if (existingCategory) {
                        existingCategory.total_fees = categoryFees[categoryId];
                    } else {
                        uniqueCategories.push({
                            ...course.category,
                            total_fees: categoryFees[categoryId] || 0,
                        });
                    }
                });
                uniqueCategories.sort((a, b) => a.order - b.order);
                uniqueCategories.map((category, index) => ({
                    ...category,
                    is_expanded: index === 0, // Expand first category by default
                }));

                setSelectedCategory(uniqueCategories[0]);

                if (uniqueCategories.length > 0) {
                    if (isNoCategory) {
                        setCategories([
                            ...uniqueCategories,
                            {
                                id: 0,
                                titleFirst,
                                titleLast: "أُخرى",
                                is_expanded: false,
                                total_fees: 0,
                            },
                        ]);
                    } else {
                        setCategories([...uniqueCategories]);
                    }
                } else {
                    setCategories([{ id: 0, noTitle: true, is_expanded: true, total_fees: 0 }]);
                }

                if (data.length < 1) {
                    setPlaceholder(
                        <div className="font-h2 col-span-1 md:col-span-2 lg:col-span-3 py-20">
                            <span className="flex-center-both space-x-3 space-x-reverse">
                                <span className="font-h1 flex-center-both text-bluefr-600 dark:text-bluefr-400">
                                    <Icon icon="carbon:data-error" />
                                </span>
                                <span>{placeholders[language]}</span>
                            </span>
                        </div>
                    );
                }
                getAll && setShowAll(true);
            }
            setIsLoading(false);
        } catch (error) {
            setPlaceholder(
                <div className="font-h2 col-span-1 md:col-span-2 lg:col-span-3 py-20">
                    <span className="flex-center-both space-x-3 space-x-reverse">
                        <span className="font-h1 flex-center-both text-bluefr-600 dark:text-bluefr-400">
                            <Icon icon="carbon:data-error" />
                        </span>
                        <span>{placeholders[language]}</span>
                    </span>
                </div>
            );
        }
    };

    useEffect(() => {
        if (coursesList) {
            setCourses(coursesList);
        } else {
            getCourses();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [coursesList, api]);

    return (
        <Container>
            <div className="flex flex-col justify-center items-center lg:flex-row gap-10">
                {/* Categories Sidebar */}
                {categories.length > 0 && categories[0]?.noTitle !== true ? (
                    <div className="w-full lg:w-1/4 space-y-6">
                        <h2 className="text-3xl font-bold text-yellow-500">
                            {titleFirst} {titleLast}
                        </h2>
                        {categories.length > 0 && (
                            <div className="space-y-4">
                                {categories.map((category) => (
                                    <motion.div
                                        key={category.id}
                                        onClick={() => setSelectedCategory(category)}
                                        className={`cursor-pointer p-4 rounded-lg border transition-all ${
                                            selectedCategory?.id === category.id
                                                ? "border-yellow-500 bg-yellow-100"
                                                : "border-gray-300"
                                        }`}
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                    >
                                        <h3 className="text-xl font-semibold text-germanAccentText">
                                            {category.titleFirst} {category.titleLast}
                                        </h3>
                                        <p className="text-gray-700">{category.description}</p>
                                        <p className="text-yellow-600 font-bold">
                                            Total Fees: {category.total_fees} LE
                                        </p>
                                    </motion.div>
                                ))}
                            </div>
                        )}
                    </div>
                ) : (
                    placeholder
                )}

                {/* Courses Section */}
                <div className="w-full lg:w-2/3 space-y-8">
                    {isLoading ? (
                        <p className="text-center text-gray-500">Loading courses...</p>
                    ) : (
                        <AnimatePresence mode="wait">
                            {selectedCategory && (
                                <motion.div
                                    key={selectedCategory.id}
                                    initial={{ opacity: 0, x: 50 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: -50 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    {/* <h3 className="text-2xl font-bold text-germanAccentText">
                                        {selectedCategory.titleFirst} {selectedCategory.titleLast}{" "}
                                        Courses
                                    </h3> */}
                                    <CourseCarousel
                                        courses={courses.filter(
                                            (course) => course.category_id === selectedCategory.id
                                        )}
                                    />
                                </motion.div>
                            )}
                        </AnimatePresence>
                    )}
                </div>
            </div>
        </Container>
    );
};

export default CoursesWithCategories;
